<ng-template #sideModal let-offcanvas>
  <div class="offcanvas-header border-bottom">
    <h5 class="offcanvas-title fw-normal" id="sideModalLabel">Table Settings</h5>
    <button type="button" class="btn-close" (click)="closeOffcanvas(offcanvas)" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">
    <ng-container>
      <app-multi-branch-selector />
      <app-date-range-selector />
    </ng-container>
  </div>
  <div class="offcanvas-footer border-top p-3">
    <div class="d-flex justify-content-end gap-2">
      <button type="button" class="btn btn-outline-secondary" (click)="resetToDefault()">
        Reset to Default
      </button>
      <button type="button" class="btn btn-primary" (click)="applyFilters()">
        Apply Settings
      </button>
    </div>
  </div>
</ng-template>
